import { warn } from "@/lib/log";
import { api } from "@/lib/api";

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

const subscribe = async () => {
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/public-key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.key) });
  }
  await api.post("/push/subscribe", sub.toJSON());
  localStorage.setItem("aurora_push", "on");
};

export async function enablePush() {
  if (!pushSupported()) throw new Error(isIOS() && !isStandalone()
    ? "On iPhone, first add SpeechFlow to your Home Screen, then enable notifications from the app"
    : "Push notifications are not supported on this browser");
  if ((await Notification.requestPermission()) !== "granted") return false;
  await subscribe();
  return true;
}

// Re-links an existing browser subscription to the currently logged-in user.
export async function syncPush() {
  if (!pushSupported() || Notification.permission !== "granted") return;
  try { await subscribe(); } catch (e) { warn("Push sync failed", e); }
}

export async function disablePushForThisDevice() {
  if (!pushSupported()) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = await reg?.pushManager.getSubscription();
    if (sub) await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
    localStorage.removeItem("aurora_push");
  } catch (e) {
    warn("Push unsubscribe failed", e);
  }
}
